// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"334":"ad89e3f0","460":"9ea05448"}[chunkId] + ".chunk.js";
};